import { useState } from "react";
import "./RefundForm.scss";
import { FaPlus } from "react-icons/fa";

export default function RefundForm({ onClose, selectedOrders, handleRefund }) {
  const [reason, setReason] = useState("");
  const [selectedReason, setSelectedReason] = useState("Out of stock");
  //console.log("selectedOrders:", selectedOrders);
  const reasonOptions = [
    "Out of stock",
    "Item discontinued",
    "Incorrect listing information",
    "unable to fulfill order",
  ];

  const [preview, setPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedExt = ["jpg", "jpeg", "png", "heic", "heif", "webp"];

    const ext = file.name.split(".").pop().toLowerCase();

    if (!allowedExt.includes(ext)) {
      setSelectedFile(null);
      setPreview(null);
      alert("Please upload a valid image (JPG, PNG, HEIC, WEBP)");
      return;
    }

    setSelectedFile(file);

    // Preview only if browser supports it
    if (file.type.startsWith("image/") && !["heic", "heif"].includes(ext)) {
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setPreview(null); // HEIC preview not supported
    }
  };

  const handleSubmit = () => {
    // Determine final reason
    const finalReason =
      selectedReason === "other" ? reason.trim() : selectedReason;

    if (!finalReason) {
      alert("Please provide a reason for cancellation.");
      return;
    }

    handleRefund(finalReason, selectedFile);
    onClose();
  };
  return (
    <div className="cancelform-container">
      <h2>REFUND ORDER?</h2>

      <span>Select reason:</span>
      <div className="reason-option-wrapper">
        <select
          className="reason-option-items"
          value={selectedReason}
          onChange={(e) => {
            setSelectedReason(e.target.value);
            setReason(""); // reset custom reason when changing selection
          }}
        >
          {reasonOptions.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
          <option value="other">Other</option>
        </select>
      </div>
      {selectedReason === "other" && (
        <div className="other-wrapper">
          <span>Please specify:</span>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason here..."
          />
        </div>
      )}
      <div className={`upload-panel-wrapper ${preview ? "hasUpload" : ""}`}>
        {preview ? (
          <div className="preview-wrapper">
            <img src={preview} alt="Receipt Preview" />
          </div>
        ) : null}

        <label className="upload-btn">
          <input
            type="file"
            accept="image/*,.heic,.heif,.webp"
            onChange={handleFileChange}
            hidden
          />
          <span>
            <FaPlus />
          </span>
          UPLOAD PROOF
        </label>
        <span>Allowed: JPG, PNG, HEIC, WEBP</span>
      </div>

      <div className="button-wrapper">
        <button className="cancel" onClick={onClose}>
          Cancel
        </button>
        <button className="submit" onClick={() => handleSubmit()}>
          Submit
        </button>
      </div>
    </div>
  );
}
